import React, { Fragment, useEffect, useState, useCallback } from 'react';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import AddIcon from '@material-ui/icons/Add';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { COLORS } from '../../styles/colors';
import MenuItem from '@material-ui/core/MenuItem';
import ButtonContent from '../ButtonContent';
import { faPlus, faVideo, faTrash } from '@fortawesome/free-solid-svg-icons'
import YouTubeVideoPreview from './../YouVideoPreview'
import WeightMetricListing from './../assignments/WeightMetricListing';
import { ConfirmJsMessage } from '../../helpers.js';
import StartCalendar from "./StartCalendar";
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import { AlertJsMessage } from './../../helpers.js';

import moment from 'moment';



const WeightMetric = props => {

	const {
		clientEmail,
        saveWeightMetric,
        user,
        fetchWeightMetricMetas,
        fetchWeightMetricRanges,
        fetchWeightMetric,
        deleteWeightMetricRange,
        isEdit,
        isMobile,
        range
	} = props;

	const [date, setDate] = useState();
    const [weight, setWeight] = useState('');
    const [bodyFat, setBodyFat] = useState('');
    const [wId, setWId] = useState(undefined);
    const [passDate, setPassDate] = useState(null);
    const [isOpenViewAction, setViewHistory] = useState(false);
 
   
    useEffect(() => {
        if (isEdit && range) {
            fetchWeightMetricList([range._id])
        }
     }, [clientEmail])


    const fetchWeightMetricList = (rangeIds) => {
        fetchWeightMetric(rangeIds)
        .then((res) => {
           const data = res.data;
           const d = data.data;
           if(d.length) {
            setWeight(d[0].weight)
            setBodyFat(d[0].bodyFat)
            setWId(d[0]._id)
           }
        })
    }

    const changeStartDate = (data) => {
        const date = new Date(data);
        setPassDate(date);
    }

    const onChange = (evt) => {
        let { value, name } = evt.target
        if (name === 'weight') {
            setWeight(value)
        }
        if (name === 'bodyFat') {
            setBodyFat(value)
        }
        
    }

    const submitData = async() => {
        if(date === '') {
            AlertJsMessage('Date is required.');
            return;
        }

        const re = /^(?:\d*\.\d{1,2}|\d+)$/;
        
        if (weight === '' && bodyFat === '') {
            AlertJsMessage('Weight or Body Fat  is required.');
            return;
        }
        if (weight !== '' &&  !re.test(weight)) {
            AlertJsMessage('Weight should be numeric with 2 decimal values.');
            return;
        }

        if (bodyFat !== '' &&  !re.test(bodyFat)) {
            AlertJsMessage('Body Fat Percentge should be numeric with 2 decimal values.');
            return;
        }

        const dateWithoutZone = moment(passDate).format('YYYY-MM-DD');
        const day = moment(dateWithoutZone).startOf('month').format('DD')
        const month = moment(dateWithoutZone).format('MM')
        const year = moment(dateWithoutZone).format('YYYY')
        const date = new Date(`${year}-${month}-${day}`)
        saveWeightMetric({
            startDate: date,
            clientEmail: clientEmail,
            weight: weight,
            bodyFat: bodyFat,
            wId: range ? wId : undefined,
            _id: range ? range._id : undefined
        })
        .then((res) => {
            if (range) {
                fetchWeightMetricList([range._id])
                console.log(res.weightMetricRangeDetails);
                if (res.weightMetricRangeDetails) {
                    props.parentData(res.weightMetricRangeDetails)
                }
            }
        })
    }

    const viewHistory = () => {
        setViewHistory(!isOpenViewAction)
    }

    let startDate;
    if (range) {
        startDate = moment(range.startDate).utc(0, true);
        const month = startDate.format('M');
        const day   = startDate.format('D');
        const year  = startDate.format('YYYY');
        startDate = new Date(`${year}-${month}-${day}`)
    }

    return (
        <Fragment>
                { !isEdit &&
                    (<div style={{
                                    marginTop: '5px',
                                    textAlign: 'right'
                                }}>
                            <Button
                                color="primary"
                                onClick={() => viewHistory()}
                                style={{
                                    color: COLORS.orange,
                                    fontSize: '10px'
                                }}
                            >
                                <ButtonContent text={ !isOpenViewAction ? "View History" : "Back" }  />
                            </Button>
                        </div> )
                    }
                    { isOpenViewAction && (
                        <WeightMetricListing
                            fetchWeightMetricRanges = { fetchWeightMetricRanges}
                            clientEmail = {clientEmail}
                            fetchWeightMetric = { fetchWeightMetric }
                            saveWeightMetric = { saveWeightMetric }
                            deleteWeightMetricRange = { deleteWeightMetricRange }
                            fetchWeightMetricMetas = { fetchWeightMetricMetas}
                            user = {user}
                            isMobile = { isMobile }
                        >
                        </WeightMetricListing>)
                    }
                    { !isOpenViewAction && (
                    <div
                        style={{
                            marginTop: !isEdit ? 25 : 0,
                            width: isMobile ? '100%' : '600px'
                        }}
                    >


                    <div style={{marginTop: '5px'}}>
                    <div style={{
                                    display: 'flow-root',
                                    padding: 20,
                                    paddingLeft: 0,
                                    width: '100%',
                                    height: '90px'
                                    }}>
                                <div style={{
                                    display: 'initial',
                                    float: 'left',
                                    width: isMobile ? '100%' : '400px'
                                }}>
                                <p><strong>Select Month</strong></p>
                                    <StartCalendar bottomLeftPosition="true" startDate={startDate} formDataPicker={'MM/YYYY'} isOnlyMonthPicker={true} changeStartDate={changeStartDate}  />
                                </div>
                                <div style={{
                                    display: 'initial',
                                    float: 'left',
                                    width: isMobile ? '100%' : '400px',
                                    marginTop: '5px'
                                }}>
                                <p><strong>Enter Weight Information in lbs.</strong></p>
                                </div>
                            </div>
                            <div style={{marginTop: '40px'}}>
                            <Fragment>
                                <div  style={{
                                    marginLeft: '2px',
                                    display: isMobile && 'flex'
                                }}>
                                    <Grid container spacing={12} style={{'marginTop': isMobile ? '25px' : '10px'}}>
                                      <Grid item xs={isMobile ? 12 : 3} style={{
                                                marginLeft: isMobile ? '0px' : 'px',
                                            }}>
                                            <TextField
                                                label="Weight"
                                                value={weight}
                                                name="weight"
                                                margin="dense"
                                                variant="outlined"
                                                onChange={event => onChange(event)}
                                                inputProps={{
                                                    maxLength: 60,
                                                }}
                                            />
                                        </Grid>
                                </Grid>
                            </div>
                            </Fragment>
                            </div>
                            <div style={{
                                    display: 'initial',
                                    float: 'left',
                                    width: isMobile ? '100%' : '400px',
                                    marginTop: '5px'
                                }}>
                                <p><strong>Enter Body Fat Percentage.</strong></p>
                                </div>
                            <div style={{marginTop: '40px'}}>
                            <Fragment>
                                <div  style={{
                                    marginLeft: '2px',
                                    display: isMobile && 'flex'
                                }}>
                                    <Grid container spacing={12} style={{'marginTop': isMobile ? '25px' : '10px'}}>
                                      <Grid item xs={isMobile ? 12 : 3} style={{
                                                marginLeft: isMobile ? '0px' : 'px',
                                            }}>
                                            <TextField
                                                label="Percentage"
                                                value={bodyFat}
                                                name="bodyFat"
                                                margin="dense"
                                                variant="outlined"
                                                onChange={event => onChange(event)}
                                                inputProps={{
                                                    maxLength: 60,
                                                }}
                                            />
                                        </Grid>
                                </Grid>
                            </div>
                            </Fragment>
                            </div>
                            <div style={{ marginTop: '10px'}}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => submitData()}
                                >
                                    <ButtonContent
                                        text="Save"
                                        icon="chevron-right" />
                                </Button>
                            </div>
                        </div>
                    </div>
                    )}
        </Fragment>
    );
};

export default WeightMetric;



// WEBPACK FOOTER //
// ./src/components/assignments/WeightMetric.js